'use strict';

var errorMsg = require('./_errorMsg');
var birthdayFields = ['bd_day', 'bd_month', 'bd_year'];

/**
 * This function search if all required fields to check a birth day are present
 * if yes a specific check will be performed to ensure we get a valid date
 * @param {*} form the form being checked
 * @returns {Object} birthdayFormData containing all birthday fields and a valid status
 */
function findBirthdayFields(form) {
    var formKeys = Object.keys(form);
    var birthdayFormData = {};
    birthdayFormData.valid = false;
    var nbFound = 0;
    for (var a = 0; a < formKeys.length; a++) {
        if (birthdayFields.indexOf(form[a].name) > -1) {
            nbFound++;
            birthdayFormData[form[a].name] = form[a];
        }
    }
    if (nbFound === birthdayFields.length) {
        birthdayFormData.valid = true;
    }
    return birthdayFormData;
}

/**
 * This function checks the attributes status depending on their type and setup
 * @param {HTMLObjectElement} element the HTML element
 * @returns {boolean} field check pass or not
 */
function testFormField(element) {
    switch (element.type) {
        case 'text':
            if (element.attributes.required) {
                if (!element.value.match(/[\w]{1,}/)) {
                    return false;
                }
            }
            break;
        case 'select':
        case 'select-one':
            if (element.attributes.required) {
                var possibleValues = ['select', ''];
                if (possibleValues.indexOf(element.value) > -1) {
                    return false;
                }
            }
            break;
        case 'checkbox':
            if (element.attributes.required) {
                if (!element.checked) {
                    return false;
                }
            }
            break;
        case 'radio':
            if (element.attributes.required) {
                if (!element.checked) {
                    return false;
                }
            }
            break;
        default:
            return true;
    }
    return true;
}

/**
 * This function resets field value to empty
 * @param {HTMLObjectElement} element the HTML element
 */
function resetFieldValue(element) {
    var el = element;
    switch (el.type) {
        case 'text':
            el.value = '';
            break;
        case 'select':
        case 'select-one':
            if (el.options.select) {
                el.value = 'select';
                el.selectedIndex = 'select';
            } else {
                el.value = '';
                el.selectedIndex = '';
            }

            break;
        case 'checkbox':
            el.checked = false;
            break;
        case 'radio':
            // do nothing
            break;
        case 'tel':
            var iti = window.intlTelInputGlobals.getInstance(element);
            if (iti) {
                iti.setNumber('');
            }
            break;
        default:
            el.value = '';
    }
    if (el.type !== 'hidden') {
        errorMsg.removeWrapperClass(el); // removes wrapper class
        errorMsg.removeAriaValidity(el); // removes Aria-invalid attribute
        errorMsg.removeLabelClass(el); // removes valid/error class of label
        errorMsg.deactivateField(el); // reset field display (set the label in the center of the field)
        errorMsg.toggleErrorWrapperClass(el, true); // Remove the red label
    }

    // Remove the field from the already checked fields
    var form = element.closest('form');
    if (form?.extendedData?.mandatoryFieldsFilled) {
        delete form.extendedData.mandatoryFieldsFilled[element.id];
    }
}

/**
 * This function deletes the error span if found
 * @param {HTMLObjectElement} element the HTML element
 */
function deleteErrorSpan(element) {
    if (element.nextSibling && element.nextSibling.nodeName === 'SPAN') {
        element.nextSibling.remove();
    }
}

/**
 * This function centralizes the behavior for enabling or not the Form Submit button
 * @param {HTMLObjectElement} element the HTML element
 * @param {boolean} status boolean that indicates which action should be performed
 */
function manageSubmitButtonDisability(element, status) {
    var mandatoryFieldsFilled = element.closest('form').extendedData.mandatoryFieldsFilled;
    if (element.attributes.required) {
        let elId = element.id;
        if (!status && mandatoryFieldsFilled !== undefined) {
            delete (mandatoryFieldsFilled[elId]);
        } else if (status && mandatoryFieldsFilled !== undefined) {
            mandatoryFieldsFilled[elId] = true;
        } else if (status) {
            let el = element;
            el.closest('form').extendedData.mandatoryFieldsFilled = [];
            el.closest('form').extendedData.mandatoryFieldsFilled[elId] = true;
            mandatoryFieldsFilled = element.closest('form').extendedData.mandatoryFieldsFilled;
        }
    }
}


/**
 * This function manages validation error for current field
 * @param {HTMLObjectElement} element the HTML element
 * @param {boolean} ctrl controler variable
 * @param {string} errorMessage error message to display, if not given, it will find the error related to the element
 */
function manageValidationError(element, ctrl, errorMessage) {
    var control = ctrl;
    control.value = 'false';

    // manages field display & aria
    errorMsg.toggleWrapperClass(element, false);
    errorMsg.toggleAriaInvalidState(element, true);

    // manages error messages
    errorMsg.toggleErrorMessage(element, false, errorMessage);

    // the below will manage the form submit button disability
    // We check the number of mandatory fields that are valid
    // against the total number of fields rendered from backEnd as mandatory
    manageSubmitButtonDisability(element, false);
}

/**
 * function manages validation valid for current field
 * @param {HTMLObjectElement} element the HTML element
 */
function manageValidationValid(element) {
    errorMsg.toggleWrapperClass(element, true);
    errorMsg.toggleAriaInvalidState(element, false);
    // manages error messages
    errorMsg.toggleErrorMessage(element, true);

    // the below will manage the form submit button disability
    // We check the number of mandatory fields that are valid
    // against the total number of fields rendered from backEnd as mandatory
    // We do not use form.checkValidity() as it triggers the form submission
    // we only want to test form validity on shadow mode (no event triggered for customer end)
    manageSubmitButtonDisability(element, true);
}

/**
 * This function manages the check and error display for radio buttons
 * PREREQUISITES :
 *      + System of checks work if a fieldset is defined and a div is declared right after
 *      + This structure has to be reproduced for any radio button group to ensure right handling
 * @param {HTMLObjectElement} element the HTML element
 * @param {HTMLFormElement} form the form
 * @param {boolean} ctrl controler variable
 */
function manageRadioCheck(element, form, ctrl) {
    var name = element.name;
    if (name && form[name].length) {
        if (form[name].value === '') {
            manageValidationError(element, ctrl);
            // in any case force control as false
            // eslint-disable-next-line no-param-reassign
            ctrl.value = 'false';
        } else {
            manageValidationValid(element);
        }
    } else if (form[name].value !== '') {
        manageValidationValid(element);
    } else {
        manageValidationError(element, ctrl);
        // in any case force control as false
        // eslint-disable-next-line no-param-reassign
        ctrl.value = 'false';
    }
}

/**
 * Add Leading Zero for safari
 * Safari consider invalid this date format : new Date('1943-2-4')
 * so always add a leading zero like that new Date('1943-02-04')
 * @param {string} numberString number string from select value
 * @returns {string} string with leading zero if < 10
*/
function addLeadingZero(numberString) {
    return parseInt(numberString, 10) < 10 ? '0' + numberString : numberString;
}

/**
 * This function checks the validity of provided birthday data
 * @param {Object} bdFields the fields passed from findBirthdayFields function
 * @param {boolean} ctrl controler variable
 * @param {string} sourceName the form sourceName
 * @param {boolean} isInitialCheck true while user input , false for form sumission
 */
function checkBirthday(bdFields, ctrl, sourceName, isInitialCheck) {
    var isTestable = birthdayFields.every((i) => Object.hasOwnProperty.call(bdFields, i));
    var missingFields = [];
    var birthdayInput = document.getElementById(sourceName + '-birthday');

    if (isTestable) {
        var notSelectedSelect = 0;

        // Check the number of <select> that has been filled (means that select value is different than "" or "select")
        for (var i = 0; i < birthdayFields.length; i++) {
            var nonSelectedOptionsPossibleValues = ['select', ''];

            if (nonSelectedOptionsPossibleValues.indexOf(bdFields[birthdayFields[i]].value) > -1) {
                notSelectedSelect++;
                missingFields.push(bdFields[birthdayFields[i]]); // useless
            }
        }

        if (isInitialCheck && notSelectedSelect !== 0) {
            // isInitialCheck let the user fill all the 3 fields before error checking
            // so do nothing until the user fill all the 3 fields, except remove previous errors
            errorMsg.resetBirthdayErrorMsg(bdFields.bd_day, 'invalid');
        } else if (notSelectedSelect === birthdayFields.length) {
            // No fields have been filled
            // Do not check anything as the fields are not mandatory, remove previous errors
            errorMsg.resetBirthdayErrorMsg(bdFields.bd_day, 'invalid');
        } else if (notSelectedSelect === 0) {
            // All select fields are filled
            var date = new Date(Date.UTC(bdFields.bd_year.value, bdFields.bd_month.value - 1, bdFields.bd_day.value));

            // Test the validity of the date by comparing it again to the fields values
            // An invalid date passed at new Date() will set the date the closest other valid day
            if (date.getUTCDate().toString() !== bdFields.bd_day.value ||
                date.getUTCMonth().toString() !== (bdFields.bd_month.value - 1).toString() || // remember that January is 0 for date.getMonth()
                date.getUTCFullYear().toString() !== bdFields.bd_year.value) {
                // The date is wrong. Set all fields to invalid
                errorMsg.bdErrorMsg(bdFields.bd_day, 'invalid');
                manageValidationError(bdFields.bd_day, ctrl);
                manageValidationError(bdFields.bd_month, ctrl);
                manageValidationError(bdFields.bd_year, ctrl);
            } else if (birthdayInput) {
                // The date is valid, remove previous errors
                errorMsg.resetBirthdayErrorMsg(bdFields.bd_day, 'invalid');

                // Fill the hidden birthday field with the date value
                var bdDay = addLeadingZero(bdFields.bd_day.value);
                var bdMonth = addLeadingZero(bdFields.bd_month.value);
                birthdayInput.value = bdMonth + '/' + bdDay + '/' + bdFields.bd_year.value;
            }
        } else {
            // All the fields haven ot been filled, at least one is missing
            errorMsg.bdErrorMsg(bdFields.bd_day, 'missing');
            manageValidationError(bdFields.bd_day, ctrl);
            manageValidationError(bdFields.bd_month, ctrl);
            manageValidationError(bdFields.bd_year, ctrl);
        }
    }
}

/**
 * this function returns current element value depending on element type
 * @param {HTMLElement} element the current HTML Element
 * @returns {string} the current element value
 */
function elementValue(element) {
    return element.value;
}

/**
 * This function restricts the trigger of check validity when specific keyboard keys are pressed
 * @param {HTMLEvent} event the current event
 * @param {HTMLElement} element the current element
 * @returns {boolean} state
 */
function restrictedKeyUp(event, element) {
    // Avoid revalidate the field when pressing one of the following keys
    // Shift       => 16
    // Ctrl        => 17
    // Alt         => 18
    // Caps lock   => 20
    // End         => 35
    // Home        => 36
    // Left arrow  => 37
    // Up arrow    => 38
    // Right arrow => 39
    // Down arrow  => 40
    // Insert      => 45
    // Num lock    => 144
    // AltGr key   => 225
    var excludedKeys = [
        16, 17, 18, 20, 35, 36, 37,
        38, 39, 40, 45, 144, 225
    ];
    let state = false;
    if ((event.which === 9 && elementValue(element) === '') || excludedKeys.indexOf(event.keyCode) !== -1) {
        state = true;
    }
    return state;
}

/**
 * this function is only here to pass data to errorMsg Management for Phone Number (iti) field
 * see: getValidationError option
 *      https://github.com/jackocnr/intl-tel-input#initialisation-options
 *
 * @param {HTMLElement} element the current html element
 * @param {string} error the error as returned by iti validator
 */
function itiManageValidationErrorMessage(element, error) {
    errorMsg.itiFindErrorState(element, error);
}

/**
 * this function empties Custom Validity Message
 * see: getValidationError option
 *      https://github.com/jackocnr/intl-tel-input#initialisation-options
 *
 * @param {HTMLElement} element the current html element
 */
function itiManageValidationValidMessage(element) {
    element.setCustomValidity('');
}

/**
 * check if an element is visible or hidden
 * it's not bulletproof but works in most cases
 * see: https://github.com/jquery/jquery/blob/main/src/css/hiddenVisibleSelectors.js
 *
 *  @param {HTMLElement} element the current html element
 *  @returns {boolean} if visible
 */
function isVisible(element) {
    return !!(element.offsetWidth || element.offsetHeight || element.getClientRects().length);
}

/**
 * Gets navigation height either in checkout or rest of the website…
 *
 *  @param {string} mode either 'checkout' or 'default'
 *  @returns {number} navigation height in px
 */
function getCurrentPageNavigationHeight(mode) {
    const navigationBar = mode === 'default' ? document.querySelector('[is="o-navigation"]') : document.querySelector('[is="m-checkout-bar"]');

    return navigationBar.offsetHeight;
}

/**
 * Similar to element.scrollIntoView() but with offset option
 * see: https://amitd.co/code/javascript/scroll-into-view-with-offset
 *
 *  @param {HTMLElement} element the html element to scroll to
 *  @param {HTMLElement} container optional html element in which we'll scroll
 */
function scrollIntoViewWithOffset(element, container = window, center = false) {
    var currentNavigationMode = 'default';
    if (document.querySelector('[is="m-checkout-bar"]')) {
        currentNavigationMode = 'checkout';
    }

    const navigationOffset = getCurrentPageNavigationHeight(currentNavigationMode);
    const comfortOffset = 30;
    const elementPosition = window.scrollY + element.getBoundingClientRect().top;
    const middle = elementPosition - (window.innerHeight / 2);
    const scrollPosition = container === window ? document.documentElement.scrollTop : container.scrollTop;
    var topValue = 0;

    if (currentNavigationMode === 'default') { // not checkout
        // not really needed but the devil is in the details…
        if (center) {
            topValue = middle;
        } else {
            if (elementPosition > scrollPosition) {
                topValue = elementPosition - comfortOffset; // we'll scroll Up ↑↑↑ (navigation will hide)
            } else {
                topValue = elementPosition - navigationOffset - comfortOffset; // we'll scroll down ↓↓↓ (navigation will show)
            }
        }
    } else { // checkout
        topValue = elementPosition - navigationOffset - comfortOffset;
    }

    container.scrollTo({
        behavior: 'smooth',
        top: topValue
    });
}

module.exports = {
    checkBirthday: checkBirthday,
    itiManageValidationErrorMessage: itiManageValidationErrorMessage,
    itiManageValidationValidMessage: itiManageValidationValidMessage,
    manageValidationError: manageValidationError,
    manageValidationValid: manageValidationValid,
    deleteErrorSpan: deleteErrorSpan,
    findBirthdayFields: findBirthdayFields,
    manageRadioCheck: manageRadioCheck,
    manageSubmitButtonDisability: manageSubmitButtonDisability,
    resetFieldValue: resetFieldValue,
    restrictedKeyUp: restrictedKeyUp,
    testFormField: testFormField,
    isVisible: isVisible,
    scrollIntoViewWithOffset: scrollIntoViewWithOffset,
    getCurrentPageNavigationHeight: getCurrentPageNavigationHeight
};
